(ns entities.estate.events
  (:require
    [very.re-frame.core :as rf]
    [graphql.core :as qu]
    [entities.estate.specs :as sp]
    )
  )

(def path [:entities :estate])

(rf/reg-entity
  :estate
  {:get
   (fn [cfx]
     {:graphql {:gql (qu/estate)
                :success [:estate/fetched]
                :error [:estate/fetch-errored]
                :cancellable? true}})
   :patch
   (fn [cfx [{:keys [data]}]]
     {:graphql {:gql (qu/update-estate {:input data})
                :success [:estate/updated]
                :error [:estate/update-errored]}})

   })

(rf/reg-event-db
  :estate/fetched
  (rf/path path)
  (fn [_ [data]]
    (get-in data [:client :estate])))

(rf/reg-event-db
  :estate/fetch-errored
  (rf/path path)
  (fn [_ [{:keys [data]}]]
    (get-in data [:client :estate])))

(rf/reg-event-db
  :estate/updated
  (rf/path path)
  (fn [_ [data]]
    (:update-estate-information data)))

(rf/reg-event-db
  :estate/update-errored
  (rf/path path)
  (fn [_ [{:keys [data]}]]
    (:update-estate-information data)))
